export const MODIFIER_HELP = Object.freeze({
    blitz: {
        id: "blitz",
        title: "Blitz",
        description:
            "A 2-minute timed run. Hardcore is always on — one repeat pick ends the run.",
    },
    hardcore: {
        id: "hardcore",
        title: "Hardcore",
        description:
            "Hearts cannot save you. Picking the same card twice ends the run.",
    },
    twisted: {
        id: "twisted",
        title: "Twisted",
        description:
            "Cards rotate after shuffles. Track each Corgi by look, not screen position.",
    },
    shy: {
        id: "shy",
        title: "Shy",
        description:
            "Cards flip face-down for a few seconds, then return face-up.",
    },
    anxious: {
        id: "anxious",
        title: "Anxious",
        description:
            "The board scrambles on its own every 5–15 seconds. Cards jiggle about 2 seconds before each scramble.",
    },
});

const MODIFIER_ORDER = ["blitz", "hardcore", "twisted", "shy", "anxious"];

export function getActiveModifierHelpItems(state = {}) {
    const active = [];

    if (state.runMode === "blitz") {
        active.push(MODIFIER_HELP.blitz);
    }
    if (state.hardcoreMode) {
        active.push(MODIFIER_HELP.hardcore);
    }
    if (state.twistedMode) {
        active.push(MODIFIER_HELP.twisted);
    }
    if (state.shyCorgisMode) {
        active.push(MODIFIER_HELP.shy);
    }
    if (state.anxiousMode) {
        active.push(MODIFIER_HELP.anxious);
    }

    return MODIFIER_ORDER.map((id) =>
        active.find((item) => item.id === id)
    ).filter(Boolean);
}
